<app-content contentTitle="{{ 'translate_attachments' | translate }}">
    <!-- Tools -->
    <ng-container tools>
        <ng-container *appHasPermissionId="requiredPermissionForLinking">
            @if (mode === 'default') {
                <button
                    (click)="showLibraryDialog()"
                    class="btn btn-sm btn-outline-white me-2"
                >
                    <i class="fa-light fa-plus"></i>
                    <span>{{ 'translate_add_from_library' | translate }}</span>
                </button>
            }
        </ng-container>

        <ng-container *appHasPermissionId="requiredPermissionForLinking">
            @if (mode === 'default') {
                <button
                    (click)="showCreateLibraryFileDialog()"
                    class="btn btn-sm btn-outline-white"
                >
                    <i class="fa-light fa-plus"></i>
                    <span> {{ 'translate_new_attachment' | translate }}</span>
                </button>
            }
        </ng-container>
    </ng-container>

    <!-- Content -->
    <app-library-file-list-full
        content
        [shownFilters]="['name']"
    ></app-library-file-list-full>
</app-content>

<!-- Template for select button -->
<ng-template let-item="item" #selectButtonTemplate>
    <button
        (click)="linkLibraryFile(item)"
        [disabled]="currentlyProcessing.has(item.id)"
        class="action-icon action-icon-primary"
        [appTooltip]="'translate_select' | translate"
    >
        <i class="fa-light fa-check"></i>
    </button>
</ng-template>

<!-- Template for the unlinking button -->
<ng-template #controlColumnTemplateRef let-item="item">
    <app-delete-button
        *appHasPermissionId="requiredPermissionForUnlinking"
        [isDisabled]="currentlyProcessing.has(item.id)"
        (delete)="unlinkLibraryFile(item)"
        [itemName]="item.name"
        [appTooltip]="'translate_unlink' | translate"
    ></app-delete-button>
</ng-template>
